import { Profile, Event } from '@/lib/types/core';
import { NavLink } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import RideCard from '@/components/ui-custom/RideCard';
import { RideOut } from '@/lib/api';

interface ProfileContentProps {
  profile: Profile;
  userEvents: Event[];
  userRides: RideOut[];
  isOwnProfile: boolean;
}

// Helper function to ensure difficulty is one of the allowed values
const getValidDifficulty = (difficulty: string | null | undefined): 'Easy' | 'Moderate' | 'Hard' | 'Expert' => {
  if (difficulty === 'Easy' || difficulty === 'Moderate' || difficulty === 'Hard') {
    return difficulty;
  }
  // Default to "Expert" if the value doesn't match the expected ones
  return 'Expert';
};

const ProfileContent = ({ profile, userEvents, userRides, isOwnProfile }: ProfileContentProps) => {
  const renderRallies = (userEvents: Event[]) => {
    return userEvents.length? (
      <div className="mb-6">
        <h2 className="heading-md mb-4">Organized Rallies</h2>
        
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {userEvents.map((event) => (
              <RideCard
                key={event.id}
                id={event.id}
                title={event.title || 'Untitled Event'}
                date={event.meeting_datetime || ''}
                location={Array.isArray(event.meeting_location) ? event.meeting_location.join(',') : ''}
                difficulty={getValidDifficulty(event.terrain_difficulty)}
                distance={event.ride_type || 'Not specified'}
                organizer={profile?.username || 'Unknown'}
              />
            ))}
          </div>
      </div>
    ) : null;
  }

  return (
    <div className="lg:col-span-2 space-y-6">
      <div className="glass-card rounded-lg p-6 mb-8">
        <h2 className="text-xl font-bold mb-4">About</h2>
        <p className="text-adv-lightGray">
          {profile?.bio || `${profile?.username} hasn't added a bio yet.`}
        </p>
      </div>
      
    </div>
  );
};

export default ProfileContent;
